interface FolderIconProps {
  className?: string
  isOpen?: boolean
  size?: number
}

export function FolderIcon({ className = '', isOpen = false, size = 16 }: FolderIconProps) {
  return (
    <div className={`${className}`} style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.40099 1.17651e-05H8.37164C10.0947 1.17651e-05 11.4914 1.50339 11.4914 3.3579C11.4914 3.41374 11.5121 3.46729 11.5487 3.50677C11.5854 3.54625 11.6352 3.56843 11.687 3.56843H15.599C18.0274 3.57422 19.9946 5.69159 20 8.30527V15.2632C19.9946 17.8768 18.0274 19.9942 15.599 20H4.40099C1.97039 20 1.09309e-05 17.8792 1.09309e-05 15.2632V4.73685C-0.00259333 3.47971 0.460243 2.27324 1.28615 1.38431C2.11206 0.495367 3.23298 -0.00279124 4.40099 1.17651e-05ZM9.99512 3.3579C9.99512 2.37542 9.25513 1.57896 8.34231 1.57896H4.40099C2.78059 1.57896 1.467 2.99279 1.467 4.73685V15.2632C1.467 17.0072 2.78059 18.4211 4.40099 18.4211H15.5697C17.1901 18.4211 18.5037 17.0072 18.5037 15.2632V8.30527C18.5037 6.56121 17.1901 5.14738 15.5697 5.14738H11.6577C10.7395 5.14738 9.99512 4.3462 9.99512 3.3579Z'
          fill='black'
        />
      </svg>
    </div>
  )
}
